import { render, staticRenderFns } from "./WeekCalendarHeader.vue?vue&type=template&id=83771702"
import script from "./WeekCalendarHeader.vue?vue&type=script&lang=js"
export * from "./WeekCalendarHeader.vue?vue&type=script&lang=js"
import style0 from "./WeekCalendarHeader.vue?vue&type=style&index=0&id=83771702&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports